import _ from "lodash";
import {
  cubeSheetId,
  cubeCameraData,
  cubeMarkup,
  cubeSelectionData,
  cubeColorData,
  cubeMagnitudeData,
  cubeFaceVisibility,
  cubeSnapshot,
  cubeLineVisibility,
  cubeCuttingData,
  cubeVisibilityData,
  cubeCurrentShadingData,
  cubeMeasurementsMarkup,
  cubeTransparencyData,
  getNodeIdsFromCubeUniqueId,
  getFileversionIdAndNodeOffsetIdMap,
  modelTransfroms,
} from "./cubeViewHelper";

export const cubeView = {
  toJson: async (viewerImpl) => {
    const visibilityData = await cubeVisibilityData.toJson();

    const data = {
      camera: cubeCameraData.toJson(),
      sheetId: cubeSheetId.toJson(),
      explodeMagnitude: cubeMagnitudeData.toJson(),
      cuttingData: cubeCuttingData.toJson(),
      lineVisibility: cubeLineVisibility.toJson(),
      faceVisibility: cubeFaceVisibility.toJson(),
      defaultVisibility: visibilityData.defaultVisibility,
      visibilityExceptions: visibilityData.visibilityExceptions,
      colors: await cubeColorData.toJson(),
      markup: await cubeMarkup.toJson(),
      measurementsMarkup: await cubeMeasurementsMarkup.toJson(),
      selection: cubeSelectionData.toJson(),
      shading: cubeCurrentShadingData.toJson(),
      name: "asdf",
      uniqueId: Communicator.UUID.create(),
      transparencies: cubeTransparencyData.toJson(),
      modelTransfroms: modelTransfroms.toJson(),
    };

    if (viewerImpl._clippingBox.isActive()) {
      data.clippingBox = await viewerImpl._clippingBox.toJson();
    }

    return data;
  },
  fromJson: async (cubeViewJsonTemp, fileVersionId) => {
    // TODO: Discuss with purval and call getFileversionIdAndNodeOffsetIdMap globally as soon as all consitutent file loads

    const cubeViewJson = _.cloneDeep(cubeViewJsonTemp);
    const mapper = getFileversionIdAndNodeOffsetIdMap(fileVersionId);
    const colors = [];
    const visibilityExceptions = [];
    const selection = [];
    const transparencies = [];

    cubeViewJson.colors.forEach((color) => {
      const nodeIds = getNodeIdsFromCubeUniqueId(color[0], mapper);
      nodeIds.forEach((node) => {
        colors.push([node, Communicator.Color.fromJson(color[1])]);
      });
    });

    cubeViewJson.colors = colors;

    cubeViewJson.visibilityExceptions.forEach((exception) => {
      const nodeIds = getNodeIdsFromCubeUniqueId(exception, mapper);
      visibilityExceptions.push(...nodeIds.map((node) => node));
    });

    cubeViewJson.visibilityExceptions = visibilityExceptions;

    cubeViewJson.selection.forEach((selectionData) => {
      const nodeIds = getNodeIdsFromCubeUniqueId(selectionData.nodeId, mapper);
      nodeIds.forEach((node) => {
        selection.push({
          ...selectionData,
          nodeId: node,
        });
      });
    });

    cubeViewJson.selection = selection;

    cubeViewJson.transparencies.elements.forEach((transparentElements) => {
      const nodeIds = getNodeIdsFromCubeUniqueId(transparentElements, mapper);
      nodeIds.forEach((node) => {
        transparencies.push(node);
      });
    });

    cubeViewJson.transparencies.elements = transparencies;

    await cubeMarkup.fromJson(cubeViewJson);
    if (Array.isArray(cubeViewJson.measurementsMarkup) && cubeViewJson.measurementsMarkup.length) {
      await cubeMeasurementsMarkup.fromJson(cubeViewJson.measurementsMarkup);
    }
    cubeViewJson.selection && cubeSelectionData.fromJson(cubeViewJson.selection);
    cubeViewJson.shading && cubeCurrentShadingData.fromJson(cubeViewJson.shading);
    if (Object.hasOwn(cubeViewJson, "transparencies")) {
      cubeTransparencyData.fromJson(cubeViewJson.transparencies);
    }
    // if(Object.hasOwn(cubeViewJson, 'clippingBox')){
    //   await viewerImpl._clippingBox.fromJson(cubeViewJson.clippingBox)
    // }
    if (cubeViewJson.modelTransfroms) modelTransfroms.fromJson(cubeViewJson.modelTransfroms);
  },
  flushView: async () => {
    await Promise.all([
      await hwv.model.resetNodesTransform(),
      hwv.measureManager.removeAllMeasurements(),
      hwv.selectionManager.clear(),
      hwv.model.resetNodesColor(),
      hwv.model.resetNodesVisibility(),
      hwv.model.resetModelTransparency(),
    ]);
  },
};

export const getCubeViewSnapshot = async () => await cubeSnapshot.toJson();
